<!-- 销售出库记账单 -->
<template>
	<el-dialog  title="销售出库记账单"  :visible.sync="dialogVisible" center  width="90%" append-to-body top="2rem">
		<div class='components_content_box'>
			<!-- <div class="components_content_top"> -->
				<!-- <div class="page_content_top_line">
					<el-form :inline="true" :model="getRequestData" class="demo-form-inline" v-if="pageShowData[0]">
						<el-form-item :label="formOneValue.showField" v-if="formOneValue.isShow==1" v-for="(formOneValue,formOneKey) in pageShowData[0].jurconfigform" :key="formOneKey">
							<el-input  v-model.trim="getRequestData[formOneValue.entityField]" size="mini" :maxlength="$store.state.inputLength"></el-input>
						</el-form-item>
					
						<el-form-item>
							<el-button type="primary"  size="mini" @click="searchData">查询</el-button>
						</el-form-item>
					</el-form>
				</div> -->
			<!-- </div> -->
			<div class="components_content_content">
				<el-table ref="multipleTable"   :data="returnData.list" border height="100%"  :row-key="getRowKeys" :expand-row-keys="expands"  @expand-change="expandSelect" highlight-current-row>
					<el-table-column type="expand" label="详情" width="70">
					    <template slot-scope="props">
							<el-tabs type="border-card">
								<el-tab-pane label="辅助信息" >
									<el-table :data="[props.row.wosupinfor]"  border  style="width: 100%">
										<el-table-column prop="coName" label="货主"></el-table-column>
										<el-table-column prop="wosiAccperiod" label="账期"></el-table-column>
										<el-table-column prop="wosiDismode" label="配送方式"></el-table-column>
										<el-table-column prop="wosiPaymode" label="付款方式"></el-table-column>
										<el-table-column prop="wosiSetmode" label="结算方式"></el-table-column>
									</el-table>
								</el-tab-pane>
								<el-tab-pane label="明细" >
									<div style="margin-bottom: .5rem;">
										<el-button @click="selectDataAction" size="mini">确定选择</el-button>
									</div>
									<el-table :data="props.row.wobkedetailInfos" height="400px"  @selection-change="handleSelectionChange"   border  style="width: 100%">
										<el-table-column type="selection"  width="55">
										</el-table-column>
										<el-table-column prop="bgmName" label="通用名称" min-width="200" fixed="left" :show-overflow-tooltip="true">
										</el-table-column>
										<el-table-column prop="bgmManufacturer" label="生产厂家	"></el-table-column>
										<el-table-column prop="bgmPlaceorigin" label="产地"></el-table-column>
										<el-table-column prop="woadBatnumber" label="批号"></el-table-column>
										<el-table-column prop="bgmSpecifications" label="规格"></el-table-column>
										<el-table-column prop="woadPnumber" label="销售数量"></el-table-column>
										<el-table-column prop="returnNum" label="已退货数量"></el-table-column>
										<el-table-column prop="woadPrice" label="单价"></el-table-column>
										<el-table-column prop="woadMoney" label="金额"></el-table-column>
										<el-table-column prop="woadPsprice" label="含税价格"></el-table-column>
										<el-table-column prop="woadPsmoney" label="含税金额"></el-table-column>
										<el-table-column prop="woadStaxrate" label="销项税率"></el-table-column>
										<el-table-column prop="woadWcost" label="库存成本"></el-table-column>
										<el-table-column prop="woadGprofit" label="毛利"></el-table-column>
										<el-table-column prop="woadSbnumber" label="灭菌批号"></el-table-column>
										<el-table-column prop="woadProdate" label="生产日期" >
											<template  slot-scope="scope">
												<div v-if="scope.row.woadProdate">
													{{$common.getLocalTime(scope.row.woadProdate)}}
												</div>
											</template>
										</el-table-column>
										<el-table-column prop="woadEffdate" label="有效期" >
											<template  slot-scope="scope">
												<div v-if="scope.row.woadEffdate">
													{{$common.getLocalTime(scope.row.woadEffdate)}}
												</div>
											</template>
										</el-table-column>
									</el-table>
								</el-tab-pane>
							</el-tabs>
					    </template>
					</el-table-column>
					<el-table-column prop="woamBusdeptName"   label="业务部门">
					</el-table-column>
					<el-table-column prop="woamSalesmanName"   label="业务员">
					</el-table-column>
					<el-table-column prop="woamSalecusName"   label="销售单位">
					</el-table-column>
					<el-table-column prop="woamOpposalesmanName" width="100"  label="对方业务员">
					</el-table-column>
					<el-table-column prop="wobkemExecuterName"   label="记账人">
					</el-table-column>
					<el-table-column prop="woamTotalnumber"   label="总数量">
					</el-table-column>
					<el-table-column prop="woamTotalcount"   label="总条目数">
					</el-table-column>
					<el-table-column prop="woamTotalmoney"   label="总金额">
					</el-table-column>
					
					<el-table-column prop="woamSaledate" width="100"   label="销售日期">
						<template  slot-scope="scope">
							<div v-if="scope.row.woamSaledate">
								{{$common.getLocalTime(scope.row.woamSaledate)}}
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="psbkmRedate" width="100"   label="记账日期">
						<template  slot-scope="scope">
							<div v-if="scope.row.psbkmRedate">
								{{$common.getLocalTime(scope.row.psbkmRedate)}}
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="woamIswmsm" width="120"   label="是否WMS管理">
						<template  slot-scope="scope">
							{{scope.row.woamIswmsm == 0 ? '否' : '是'}}
						</template>
					</el-table-column>
					<el-table-column prop="psbkmRemark"  width="120" label="备注">
					</el-table-column>
				</el-table>
			</div>
			<div class="components_content_bottom">
				<el-pagination
					background
					@size-change="setDataPageSize"
					@current-change="setDataPageNumber"
					:current-page="getRequestData.page"
					:page-sizes="[30,50,100,500]"
					:page-size="30"
					layout="total, sizes, prev, pager, next, jumper"
					:total="returnData.total">
				</el-pagination>
			</div>
		</div>
	</el-dialog>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
	name:'salesbookkeepingTemplate',
	//import引入的组件需要注入到对象中才能使用
	components: {},
	data() {
		//这里存放数据
		return {
			dialogVisible:false,
			getRequestData:{
				bgmName:'',
				bgmActivestatus:'',
				page:1,
				rows:30,
				start:'',
				end:'',
			},
			returnData:{
				pages:0,  // 总页数
				total:0,  // 总条数
				pageNum:0,  // 当前页数
				list:[]
			},
			
			pageShowData:[],
			formDataList:[],
			expands:[],
			selectedDetailsList:[],
			getRowKeys(row) { // 行数据的Key
			    return row.wobkemId
			},
			
		};
	},
	//监听属性 类似于data概念
	computed: {},
	//监控data中的数据变化
	watch: {
	},
	//方法集合
	methods: {
		// table每次只能展开一行
		expandSelect(row, expandedRows) {
			console.log(expandedRows)
		    this.expands = []
		    if (expandedRows.length > 0) {
				row ? this.expands.push(row.wobkemId) : ''
				this.selectedDetailsList = []
		    }
			
		},
		handleSelectionChange(data){
			this.selectedDetailsList = data
		},
		selectDataAction(){
			if(this.selectedDetailsList.length<=0){
				this.$message({
					message: '未选择明细数据',
					type: 'error'
				});
				return false
			} 
			this.dialogVisible = false
			this.$parent.extractData(this.selectedDetailsList)
		},
		openBox(){
			// this.getPageInfo()
			this.getDataList()
			this.dialogVisible = true
			this.selectedDetailsList = []
		},
	
		// 数据搜索
		searchData() {
			this.getRequestData.page = 1
			this.getDataList()
		},
		// 数据翻页
		setDataPageNumber(val){
			this.getRequestData.page = val
			this.getDataList()
		},
		
		// 切换显示条数
		setDataPageSize(val){
			this.getRequestData.page = 1
			this.getRequestData.rows = val
			this.getDataList()
		},
		
		
		// 获取数据列表
		async getDataList(){
			let responseData =  await this.$http.getSalesBookkeeping(this.getRequestData)
			if(responseData.status == 200){
				this.returnData.list = responseData.result.list
				this.returnData.pages = responseData.result.pages
				this.returnData.total = responseData.result.total
				this.returnData.pageNum = responseData.result.pageNum
				this.selectedDataList = []
				this.selectDetails = []
			}else{
				this.$message({
					message: responseData.message,
					type: 'error'
				});
			}
            this.$refs.multipleTable.doLayout();
		},
		
		
	},
	//生命周期 - 创建完成（可以访问当前this实例）
	created() {
		
	},
	//生命周期 - 挂载完成（可以访问DOM元素）
	mounted() {

	},
	beforeCreate() {}, //生命周期 - 创建之前
	beforeMount() {}, //生命周期 - 挂载之前
	beforeUpdate() {}, //生命周期 - 更新之前
	updated() {}, //生命周期 - 更新之后
	beforeDestroy() {}, //生命周期 - 销毁之前
	destroyed() {}, //生命周期 - 销毁完成
	activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style  scoped>
.table_content_tag{
	margin-right: 1rem;
}
.el-tabs--border-card_new{
	height: 85vh;
	overflow-y: scroll;
}
</style>
